import keyMirror from 'keymirror';
import Cookies from 'js-cookie';

export const shopActionTypes = keyMirror({
	GET_SHOP_DATA: null,
	GET_SHOP_DATA_SUCCESS: null,

	GET_PAYMENT_REQUESTS_SHOP_DATA: null,
	GET_PAYMENT_REQUESTS_SHOP_DATA_SUCCESS: null,

	GET_PAYMENT_METHODS_REQUEST: null,
	GET_PAYMENT_METHODS_SUCCESS: null,

	HANDLE_SUBSCRIPTION_REQUEST: null,
	HANDLE_SUBSCRIPTION_SUCCESS: null,

	CLEAN_SHOP_DATA: null,

	GET_FAILED_PAYMENTS_REQUEST: null,
	GET_FAILED_PAYMENTS_SUCCESS: null,
});

export const getNumberFromPrice = (price) =>
	price && Number(price.split(' ')[1].split(',').join('.'));

export const paymentType = {
	bcmc: 'bancontact',
	scheme: 'card',
};

export const getStylesConfiguration = (theme) => ({
	styles: {
		...(theme === 'dark'
			? {
				base: { color: 'white' },
				error: { color: 'white' },
				validated: { color: 'white' },
			  }
			: {}),
	},
});

export const getGclidFromCookie = () => {
	const gclAw = Cookies.get('_gcl_aw');

	if (!gclAw) return null;

	const parts = gclAw.split('.');
	return parts.length === 3 ? parts[2] : null;
};
